import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { Mutation } from 'vuex-class';
import store from '@/store/store';

import SnackbarUtils from '@/../bower_components/teknisavuecomponents/assets/utils/SnackbarUtils';
import ToolbarAction from '@/../bower_components/teknisavuecomponents/assets/interfaces/ToolbarAction';
import Estrutura from '@/../bower_components/teknisavuecomponents/assets/interfaces/Estrutura';
import EditableTableColumn from '@/../bower_components/teknisavuecomponents/assets/interfaces/EditableTableColumn';
import EditableTable from '@/../bower_components/teknisavuecomponents/components/grids/EditableTable.vue';
import AdmissaoController from '@/assets/ts/controller/AdmissaoController';
import User from '@/../bower_components/teknisavuecomponents/assets/interfaces/User';
import NovoComunicadoAcidenteTrabalhoPopup from '@/components/ComunicadoAcidenteTrabalho/NovoComunicadoAcidenteTrabalhoPopup/NovoComunicadoAcidenteTrabalhoPopup.vue';
import Action from '@/../bower_components/teknisavuecomponents/assets/interfaces/Action';
import Messages from '@/assets/ts/utils/Messages';
import Util from '@/assets/ts/utils/Util';
import ControleEntregaEPIController from '@/assets/ts/controller/ControleEntregaEPIController';
import DialogUtils from '@/../bower_components/teknisavuecomponents/assets/utils/DialogUtils';
import TkVisualizer from '@/../bower_components/teknisavuecomponents/components/document/TkVisualizer/TkVisualizer.vue';
import PopupController from '@/assets/ts/controller/PopupController';
import ComunicadoAcidenteTrabalhoController from '@/assets/ts/controller/ComunicadoAcidenteTrabalhoController';
import PopUpRetornoEsocial from '@//components/ESocial/PopUpRetornoEsocial.vue';
import { ControleAcessoWrapper } from '@/assets/ts/controller/ControleAcessoController';

@Component({
  name: 'ComunicadoAcidenteTrabalho',
  components: {
    EditableTable,
    NovoComunicadoAcidenteTrabalhoPopup,
    TkVisualizer,
    PopUpRetornoEsocial
  },
})
class ComunicadoAcidenteTrabalho extends Vue {
  // #region [ PROPS ]
  @Prop({ default: 'edit' })
  private readonly mode: string;
  
  @Prop({ default: () => {} })
  private readonly row: any;
  
  @Prop({ default: false })
  private readonly value: boolean;
  // #endregion


  // #region [ STORE ]
  private get estruturaGerencialAtual(): Estrutura {
    return this.$store.getters.estruturaGerencialAtual;
  }

  private get user(): any {
    return this.$store.getters.user;
  }

  @Mutation('changeCurrentView')
  private changeCurrentView: (string) => void;

  // #endregion

  // #region [ DATA ]
  private readonly viewTitle = 'CAT - Comunicado de Acidente de Trabalho';

  private comunicados: any[] = [];

  private loading = false;

  private showPopup: boolean = false;
  private retornoData : any[] = [];


  private toolbarActions: ToolbarAction[] = [
    {
      name: 'reload',
      label: 'Atualizar',
      icon: 'mdi-refresh',
      onClick: this.reload,
    },
    {
      name: 'add',
      label: 'Adicionar',
      icon: 'mdi-plus-circle',
      onClick: ControleAcessoWrapper.criar(this.addCAT),
    },
  ];

  private columns: EditableTableColumn[] = [
    {
      text: 'Vitima',
      value: 'NMVINCULOM',
      type: 'text',
    },
    {
      text: 'Descrição',
      value: 'DSOCORRENCIA',
      type: 'text',
    },
   
    
  ];

  private actions: Action[] = [
    {
      name: 'view',
      label: 'Visualizar',
      icon: 'mdi-eye',
      onClick: this.viewCAT,
      mode: 'view',
    },
    {
      name: 'Editar',
      label: 'Editar',
      icon: 'mdi-pencil',
      onClick: ControleAcessoWrapper.atualizar(this.editCAT),
      mode: 'view',
    },
    {
      name: 'Excluir',
      label: 'Excluir',
      icon: 'mdi-delete',
      onClick: ControleAcessoWrapper.deletar(this.removeCAT),
      mode: 'view',
    },
    {
      name: 'esocial',
      label: 'eSocial',
      icon: 'mdi-file-send',
      onClick: ControleAcessoWrapper.criar(this.transmissaoEsocial),
      mode: 'view',
    },
  ];

  private novoComunicadoAcidenteTrabalho = {
    show: false,
    mode: null,
    row: {},
    is_new: true,
  };

  private visualizer = {
    show: false,
  };

  // #endregion

  // #region [ COMPUTED ]
  private get isDP(): boolean {
    return this.user.dp;
  }
  // #endregion

  // #region [ LIFECYCLE ]
  private created() {
    this.changeCurrentView(this.viewTitle);
  }

  private mounted() {
    this.reload();
  }

  private destroyed() {
  
  }

  // #endregion

  // #region [ WATCHERS ]
  @Watch('estruturaGerencialAtual')
  private estruturaOnChange() {
    this.reload();
  }
  // #endregion

  // #region [ METHODS ]
  private async reload() {
    this.loading = true;
    this.comunicados = [];

    try {
      const cat = await ComunicadoAcidenteTrabalhoController.getComunicadoAcidenteTrabalho();
      this.comunicados = cat;
      this.loading = false;
    } catch (err) {
      let message = '';
      let err2 = err as any;

      if (err2.name === 'ExpectedError') {
        message = err2.message;
        message = message.replace('(HCMSERVICES) ', '');
      } else {
        message = 'Não foi possível carregar os Comunicados de Acidente de Trabalho!';
      }

      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);
    } finally {
    }
  }


  private async addCAT() {
    this.novoComunicadoAcidenteTrabalho.show = true;
    this.novoComunicadoAcidenteTrabalho.mode = 'new';
    this.novoComunicadoAcidenteTrabalho.row = {};
  }

  private async editCAT(row: any) {
    this.novoComunicadoAcidenteTrabalho.show = true;
    this.novoComunicadoAcidenteTrabalho.mode = 'edit';
    this.novoComunicadoAcidenteTrabalho.row = row;
  }

  private viewCAT(row: any) {
   this.novoComunicadoAcidenteTrabalho.show = true;
   this.novoComunicadoAcidenteTrabalho.mode = 'view';
   this.novoComunicadoAcidenteTrabalho.row = row;
  }

  
  private async transmissaoEsocial(row: any) {
    await DialogUtils.show('Envio Esocial Comunicado de Acidente de Trabalho', 'Deseja realizar o envio do Comunicado de Acidente de Trabalho para o eSocial?');
   
    const retorno = await ComunicadoAcidenteTrabalhoController.transmissaoEsocial(row);

    this.retornoData = retorno.map((msg) => {
      return {
        MSG: msg.MSG,
        TYPE: msg.TYPE,
        NRCHAVE: msg.NRCHAVE,
        NMEVENTO: msg.NMEVENTO,
      };
    })

    this.showPopup = true;
  }

  private async removeCAT(row: any) {
    await DialogUtils.show('Exluir Comunicado de Acidente de Trabalho', 'Deseja realmente excluir o Comunicado de Acidente de Trabalho?');
    const success = await ComunicadoAcidenteTrabalhoController.deleteComunicadoAcidenteTrabalho(row);
    if (success) {
      this.reload();
    }
  }



  private afterSave() {
    this.reload();
  }

  // #endregion
}

export default ComunicadoAcidenteTrabalho;

